import { FC } from 'react';
import { CardContent } from '@mui/material';
import { Typography } from '@wellstone-solutions/web';
import { Trans } from 'react-i18next';

import { Button } from '@components/ui';
import { CardHeader } from '@components/ui/Card';

interface AccountCreatedProps {
  email?: string;
  onResend?: () => void;
}

export const AccountCreated: FC<AccountCreatedProps> = ({
  email,
  onResend = () => {},
}) => {
  return (
    <>
      <CardHeader
        title={[
          <Trans
            key="auth.verify.title"
            i18nKey="auth.verify.title"
            defaultValue="Account created!"
          />,
          <Trans
            key="auth.verify.subtitle"
            i18nKey="auth.verify.subtitle"
            defaultValue="Next, validate your email."
          />,
        ]}
      />
      <CardContent sx={styles.cardContent}>
        <Typography color="text.secondary">
          {email ? (
            <Trans
              i18nKey="auth.verify.description_with_email"
              values={{ email }}
              defaultValue="We've sent a validation link to {{email}}. Please check your inbox and tap the link to verify your account."
            />
          ) : (
            <Trans
              i18nKey="auth.verify.description"
              defaultValue="We've sent a validation link to your email. Please check your inbox and tap the link to verify your account."
            />
          )}
        </Typography>
        <Typography fontWeight="bold" color="text.secondary">
          <Trans
            i18nKey="auth.verify.expiry"
            defaultValue="👉 Heads up! The link will expire in 15 minutes."
          />
        </Typography>
        <Typography color="text.secondary">
          <Trans
            i18nKey="auth.verify.no_email"
            components={{ strong: <strong /> }}
            defaultValue="🤨 <strong>Didn't get the email?</strong> Check your spam or junk folder, or we can resend you a new email."
          />
        </Typography>
        <Button variant="outlined" onClick={onResend} sx={styles.resendButton}>
          <Trans i18nKey="auth.verify.resend" defaultValue="Resend email" />
        </Button>
      </CardContent>
    </>
  );
};

const styles = {
  cardContent: {
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.625rem',
  },
  resendButton: { alignSelf: 'center', width: 'auto' },
};
